import Lottie from 'lottie-react';
import animation from '../../../static/lottie/walking-avocado.json';

const lottieIconStyles = {
  width: '280px',
  height: '280px',
};

const AnimatedAvocado = () => {
  return <Lottie loop style={lottieIconStyles} animationData={animation} />;
};

export default AnimatedAvocado;
